/**
 * `entities/taxonomy-category` query options.
 *
 * Direct hey-api calls by URL (not in the generated SDK yet), same convention
 * as `entities/taxonomy`.
 */
import { queryOptions } from '@tanstack/react-query';
import { assetsHttp } from '@/lib/api/http-client';
import type { TaxonomyCategory } from '../model/types';

const CATEGORIES_URL = '/api/v1/taxonomy-categories';

export const TAXONOMY_CATEGORY_QUERY_KEYS = {
  all: ['taxonomy-categories'] as const,
  // eslint-disable-next-line i18next/no-literal-string -- React Query cache key
  list: () => [...TAXONOMY_CATEGORY_QUERY_KEYS.all, 'list'] as const,
};

export const taxonomyCategoriesQueryOptions = () =>
  queryOptions({
    queryKey: TAXONOMY_CATEGORY_QUERY_KEYS.list(),
    queryFn: async ({ signal }) => {
      const response = await assetsHttp.get({ throwOnError: true, url: CATEGORIES_URL, signal });
      return (response.data as TaxonomyCategory[] | undefined) ?? [];
    },
  });
